export class TableType {
    id: number;
    code: string;
    name: string;
    active: boolean;
    type: string;
}